export default __webpack_public_path__ + "static/media/CNo.81-2.14ab1556.jpg";